import { Sparkles } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useAssistant } from './assistant-context';

export const AssistantButton = () => {
  const { toggle, isOpen } = useAssistant();
  return (
    <Button
      type="button"
      variant="secondary"
      size="sm"
      onClick={toggle}
      aria-expanded={isOpen}
      aria-controls="gainsignal-assistant"
    >
      <Sparkles />
      Ask AI
      <span className="hidden text-[11px] font-normal text-ink-subtle xl:inline">
        ⌘J
      </span>
    </Button>
  );
};
